export const UrlPath={
    Home:`/Home`,
    Asset:`/Asset`,
    AssetDetails:`/Asset/Details/`,
    AssetTaxDetails:`/Asset/Tax/`,
    AssetFinancialStatement:`/Asset/FinancialStatements/`,
    AssetHolding:`/Asset/Holdings/`,
    AssetEdit:`/Asset/AssetEdit/`,
    AssetAdd:`/Asset/AssetAdd`,
    AssetReturnStatics :`Asset/Analytics/`,
    AssetSetting:`/Asset/Settings/`, 
    AssetShareClassEdit:`/Asset/ShareClassEdit/`,
    AssetShareClassAdd:`/Asset/ShareClassAdd/`,
    AssetAttributesEdit:`/Asset/AttributesEdit/`,
    AssetAttributesAdd:`/Asset/AttributesAdd/`,
    AssetTax: `/Asset/Tax/`,
    Profile: `/Home/Profile`,
    DocumentsInvestment:`/Documents/Investment`,
    Documents: `/Documents`,
    DocumentsInvestmentEdit: `/Documents/InvestmentEdit/`,
    DocumentsInvestmentAdd: `/Documents/InvestmentAdd/`,
    DocumentInvestor: '/Documents/Investor',
    DocumentInvestorAdd: '/Documents/InvestorAdd',
    DocumentInvestorEdit: '/Documents/InvestorEdit/',
    UniverseList:`/AnalyticsReporting/PeerAnalytics`,
    Liquidity:`Asset/Liquidity`,
   // UniverseSearch:`/UniverseSearch/`,
    UniverseMembers:`/AnalyticsReporting/PeerAnalytics/UniverseDetail/`,
    UniverseEdit:`/universe/Edit/`,
    UniverseAdd:`/universe/Add`,
    UniverseAnalytics:'/AnalyticsReporting/PeerAnalytics/UniverseAnalytics/',
    Analytics:`/Analytics`,
    AnalyticsReporting:`/Analytics & Reporting`,
    MarketData:'/AnalyticsReporting/marketData',
    MarketDataDetails:`/Details/`,
    MarketDataEdit:`/marketData/MarketDataEdit/`,
    MarketDataAdd:`/marketData/MarketDataAdd`,
    MarketDataSettings:`/marketData/MarketDataSettings/`,
    MarketAnalytics:`/Analytics/`,
    MonitoringException:`/Analytics/MonitoringException`,
    Exposures:`/Asset/Exposures/`,
    AnalystExposure:`/Asset/Exposures/Analyst/`,
    PrivateExposure:`/Asset/Exposures/Private/`,
    PublicExposure:`/Asset/Exposures/Public/`,
    EmailRulesList:`/Asset/EmailRules/`,
    AddEmailRules:`/EmailRules/Add`,
    EditEmailRules:`/EmailRules/Edit/`,
    AUMList:`/AssetAUM/`,
    Valuation:`/Asset/Valuations/`,
    ValuationPostPricing: `/Asset/Valuations/Edit/`,
    MarketablePostPricing: `/Asset/MarketablePostPricing/Edit/`,
    PostPricing:`/Asset/PostPricing/`,
    Permissions:`/Admin/Permissions/`,
    Admin: `/Admin/`,
    MonitoringExceptionSettings: `Admin/ExceptionTolerance`,
    MonitoringExceptionType:`/Admin/MonitoringExceptionType`,
    MonitoringNotificationDetails:'/Admin/MonitoringNotificationDetails',
    UserPageTracking:`/Admin/UserPageTrackingReport`,
    UsersLastLogin: `/Admin/UsersLastLogin`,
    ClientReportingSettings:`/Admin/ClientReportingSettings`,
    MarketAnalyticsPostPricing:`/Analytics/PostPricing/`,
    ApplicationSettings: `/Admin/ApplicationSettings`,
    Classfications: `/Admin/Classifications`,
    ServerInfo: `/Admin/ServerInfo`,
    Billing:'/Admin/Billing',
    BillingPreview:'/Admin/BillingPreview/',
    MarketableSecuritiesFeed:'/Admin/MarketableSecuritiesFeed',
    WebPortalSync:'/Admin/WebPortalSync',
    ClientWebsites:'/Admin/ClientWebsites',
    Partnership:'/Admin/Partnerships/Partnership',
    PartnershipSetup:'/Admin/Partnerships/PartnershipSetup',
    DDQSetup:'/Admin/DDQ_Setup',
    PPLISetup: '/Admin/Partnerships/PPLI_Setup',
    Custodians: '/Admin/Custodians',
    TrainModel: '/Admin/TrainModel',
    // Investor menus
    Investor:`/CRM`,
    Investment:`/Investment/contact/`,
    InvestorDetails:`/Investor/Details/`,
    InvestorLists:`/Investor/Lists`,
    InvestorDetailsEdit:`/Investor/Details/Edit/`,
    InvestorTracking:`/Investor/Tracker`,
    InvestorAccounts:`/Investor/Accounts`,
    InvestorAccountDetails:`/Investor/Accounts/details/`,
    InvestorAccountEdit:`/Investor/Accounts/Edit/`,
    InvestorAccountAdd:`/Investor/Accounts/Add`,
    Tasks:`/Investor/Tasks`,
    ClientStatements:`/Investor/ClientStatement`,
    Opportunities: '/Investor/Opportunities',
    EmailMarketing: '/Investor/EmailMarketing',


    CompanyDetails:`/Company/Details/`,
    CompanyDetailsEdit:`/Company/Details/Edit/`,
    ProformaConstruction:`/AnalyticsReporting/PeerAnalytics/ProformaConstruction`,
    NewProformaConstruction: `/AnalyticsReporting/PeerAnalytics/ProformaConstruction/CreateNew`,

    //portfolio
    PortfolioValuation: `Portfolio/Valuations/`,
    PortfolioPricing: `Portfolio/Valuation/Pricing`,
    PortfolioAssetAum: `Portfolio/Valuation/AssetAum`,
    Reports:`Reporting`,
    standardReports:`StandardReports`,
    PortfolioList:'Portfolio',
    PortfolioDetails:'Portfolio/Details/',
    portfolioTransaction:'Portfolio/Transactions/',
    portfolioTransactionCommitment:'Portfolio/Transactions/Commitment/',
    PortfolioAllocation: `Portfolio/Transactions/Subscription/`,
    PortfolioCapitalcall: `Portfolio/Transactions/CapitalCall/`,
    PortfolioJournalEntry: `Portfolio/Transactions/JournalEntry/`, 
    PortfolioAttribution: `Portfolio/Attribution/`,
    PortfolioAddToPortfolio: `Portfolio/Transactions/AddToPortfolio/`,
    PortfolioPayout: `Portfolio/Transactions/Payout/`,
    PortfolioRedemption: `Portfolio/Transactions/Redemption/`,
    PortfolioReceiveCash: `Portfolio/Transactions/CashReceived/`,
    PortfolioDistribution: `Portfolio/Transactions/Distribution/`,
    PortfolioLiquidity:`Portfolio/Liquidity/:portfolioId`,
    AssetAllocation:`Portfolio/AssetAllocation/`,
    PortfolioPerfAndStats: `Portfolio/PerformanceAndStatistics/:portfolioId`,
    //Transactions
    Transactions:`/Asset/Transactions/`,
    Commitment:`/Asset/Transactions/Commitment/`,
    Allocation:`/Asset/Transactions/Subscription/`,
    AddToPortfolio:`/Asset/Transactions/AddToPortfolio/`,
    Redemption:`/Asset/Transactions/Redemption/`,
    Distribution:`/Asset/Transactions/Distribution/`,
    ReceiveCash:`/Asset/Transactions/CashReceived/`,
    Payout:`/Asset/Transactions/Payout/`,
    AssetCapitalcall: `Asset/Transactions/CapitalCall/`,
    AssetJournalEntry: `Asset/Transactions/JournalEntry/`, 



    //Duedilligence
    Duediligence:`/Asset/Duediligence/`,
    //InvestorTracking
    InvestorTrackingSubscription: `/Investor/Tracker/Subscription/`,
    InvestorTrackingRedemption: `/Investor/Tracker/Redemption/`,
    InvestorTrackingCommitment: `/Investor/Tracker/Commitment/`,
    InvestorTrackingCapitalCall: `/Investor/Tracker/CapitalCall/`,
    InvestorTrackingDistribution: `/Investor/Tracker/Distribution/`,
    InvestorTrackingBulkUpload: `/Investor/Tracker/BulkUpload`,
    InvestorTrackingRedeemFee: `/Investor/Tracker/RedeemFee/`,
    InvestorTrackingRedeemReallocate:`/Investor/Tracker/RedeemReallocate/`,
    Help: `/Helper/Help`,

    ChatBotUsageLogs: `/Admin/GenAI/ChatBotUsage`,
    

    Settings: `/Settings`,



    ClientReturnList: `/Client Returns`,
    ClientReturnDetails: `/ClientReturns/Details`,
    ClientReturnAnalytics: `/ClientReturns/Analytics`,


    ThirdPartyData:'/AnalyticsReporting/ThirdPartyData/',
    ThirdPartyDataDetails:'/AnalyticsReporting/ThirdPartyDataDetails/',
    ThirdPartyDataAnalytics:'/AnalyticsReporting/ThirdPartyDataAnalytics/',


    
    PThirdPartyData:'/Portfolio/ThirdPartyData/',
    PThirdPartyDataDetails:'/Portfolio/ThirdPartyDataDetails/',
    PThirdPartyDataAnalytics:'/Portfolio/ThirdPartyDataAnalytics/',



    AdminNotification:'/Admin/Notification'
   
}